import { helpers, mui, React, ts, ui } from '_core';

import { transform } from './helper';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  file: string;
  fullScreen: boolean;
  title: string;
};

const Chart = ({ id, readOnly, loadWidgetData, file, fullScreen, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);
  const [selectedTab, setSelectedTab] = React.useState<'INDUSTRY' | 'OTHERS'>('OTHERS');

  const loadData = async (tab: 'INDUSTRY' | 'OTHERS') => {
    try {
      const response = await loadWidgetData({
        data: {
          file,
          query: ['tab', 'equals', tab],
          rename: { build_date: 'date' },
        },
      });
      if (response) {
        setData(transform(response.data));
      }
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (file) loadData(selectedTab);
    return () => setData(null);
  }, [file, selectedTab]);

  const getTabs = () => {
    return (
      <mui.core.Tabs
        indicatorColor="primary"
        textColor="primary"
        value={selectedTab}
        onChange={(_e, newTab) => setSelectedTab(newTab)}
      >
        <mui.core.Tab label="Style Factors" value="OTHERS" />
        <mui.core.Tab label="Industries" value="INDUSTRY" />
      </mui.core.Tabs>
    );
  };

  return (
    <mui.core.Box display="flex" flexDirection="column" style={{ height: '100%' }}>
      {getTabs()}
      <mui.core.Box p={3} flex="1">
        <ui.LineChart
          id={id}
          data={data}
          fullScreen={fullScreen}
          readOnly={readOnly}
          alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
          exportTitle={title}
          numberFormat="#.##%"
        />
      </mui.core.Box>
    </mui.core.Box>
  );
};

export default Chart;
